import React, { useState } from 'react'
import PropTypes from 'prop-types'
const Tooltip = ({ message, title }) => {
  const [display, setDisplay] = useState(false)
  const toggle = (event) => {
    if (event) {
      event.preventDefault()
    }
    setDisplay(!display)
  }
  return (
    <div className="relative">
      <button
        type="button"
        onClick={toggle}
        className="bg-green text-white rounded-full text-xs flex items-center justify-center"
        style={{ fontFamily: "'courier', 'monospace', 'sans-serif'", width: 24, height: 24 }}
        tabIndex="-1"
      >
        i
      </button>
      {display ? (
        <>
          <div className="absolute arrow-right" style={{ top: '10%', right: 25 }} />
          <div
            className="absolute rounded shadow-sm text-fastigoWhite bg-green p-4 w-96"
            style={{ top: '-25%', right: 35 }}
          >
            <div className="w-full flex justify-end">
              <button
                style={{ fontSize: '0.6rem' }}
                className="uppercase text-xs underline"
                onClick={toggle}
              >
                Stäng
              </button>
            </div>
            <h4 className="text-sm font-mediun">{title}</h4>
            <p className="text-xs mt-2">{message}</p>
          </div>
        </>
      ) : null}
    </div>
  )
}

Tooltip.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
export default Tooltip
